export default "__VITE_ASSET__CNC3xRr3__"